import { Reducer } from 'redux';

import { MediaManagerState, FileStatuses } from './types';

const defaultState: MediaManagerState = {
    isOpened: false,
    isUploaderOpened: false,
    filesList: [],
};

const updateFileStatus = (state: MediaManagerState, payload: FileStatuses): MediaManagerState => {
    const { filesList } = state;
    const { id, statuses } = payload;

    const updatedFilesList = filesList.map((file) => {
        if (file.id === id) {
            return { ...file, ...statuses };
        }
        return file;
    });

    return {
        filesList: updatedFilesList,
    };
};

const reducer: Reducer<MediaManagerState> = (state: MediaManagerState = defaultState, action): MediaManagerState => {
    const { payload } = action;

    switch (action.type) {
        case '@@mediaManager/SHOW_MEDIA_MANAGER':
        case '@@mediaManager/HIDE_MEDIA_MANAGER':
            return {
                ...state,
                ...{
                    isOpened: payload.isOpened,
                },
            };
        case '@@mediaManager/SHOW_MEDIA_MANAGER_UPLOADER':
        case '@@mediaManager/HIDE_MEDIA_MANAGER_UPLOADER':
            return {
                ...state,
                ...{
                    isUploaderOpened: payload.isUploaderOpened,
                },
                ...{ filesList: [] },
            };
        case '@@mediaManager/SHOW_FILE_UPLOAD':
            return {
                ...state,
                filesList: [payload.file, ...state.filesList],
            };

        case '@@mediaManager/SHOW_FILE_UPLOAD_PROGRESS':
        case '@@mediaManager/SHOW_FILE_UPLOAD_SUCCESS':
        case '@@mediaManager/SHOW_FILE_UPLOAD_ERROR':
            return {
                ...state,
                ...updateFileStatus(state, payload),
            };
        default:
            return state;
    }
};

export { reducer as mediaManager };

export default reducer;
